import { render, staticRenderFns } from "./icon-blog.vue?vue&type=template&id=6f18b772&scoped=true"
import script from "./icon-blog.vue?vue&type=script&lang=js"
export * from "./icon-blog.vue?vue&type=script&lang=js"
import style0 from "./icon-blog.vue?vue&type=style&index=0&id=6f18b772&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f18b772",
  null
  
)

export default component.exports